import React from "react";
import { Route, Routes } from "react-router-dom";

import { Profile } from "../seller/pages/Account/Profile";
import { Payment } from "../seller/pages/Payment/Payment";
import { Transaction } from "../seller/pages/Transaction/Transaction";
import { Coupons } from "../admin/pages/Coupons/Coupons";
import { AddNewCoupon } from "../admin/pages/Coupons/AddNewCoupon";
import { HomePage } from "../admin/pages/HomePage/HomePage";
import { AdminDashBoard } from "../admin/pages/DashBoard/AdminDashBoard";
import { ElectricsCategory } from "../admin/pages/Electrics Category/ElectricsCategory";
import { ShopByCategory } from "../admin/pages/ShopByCategory/ShopByCategory";
import { Deals } from "../admin/pages/Deals/Deals";
import { MainDashBoard } from "../admin/pages/DashBoard/MainDashBoard";

export const AdminRoutes = () => {
  return (
    <div >
      <Routes>
        {/* chia nho route re nhanh tu seller de de maintain */}
        <Route path="/" element={<MainDashBoard/>} />
        <Route path="/coupons" element={<Coupons />} />
        <Route path="/add-coupon" element={<AddNewCoupon />} />
        <Route path="/homepage" element={<HomePage />} />
        <Route path="/electronics-category" element={<ElectricsCategory />} />
        <Route path="/shopby-category" element={<ShopByCategory />} />
        <Route path="/deals" element={<Deals/>} />
      </Routes>
    </div>
  );
};
